import { ref } from 'vue';

const MELTINGSPOT_JS_URL = 'https://cdn.jsdelivr.net/npm/@meltingspot/meltingspot-js';
const MELTINGSPOT_CSS_URL = 'https://cdn.jsdelivr.net/npm/@meltingspot/meltingspot-js/index.min.css';
const SPOT_ID = '2a9da0a0-8716-4e12-9367-ced69d06435a';

// Module-level singleton state (shared across all component instances)
let loadingPromise = null;
let instanceCounter = 0;
const boundElements = new Set();

const isReady = ref(false);
const hasError = ref(false);

const loadCSS = () => {
    if (document.querySelector(`link[href="${MELTINGSPOT_CSS_URL}"]`)) {
        return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = MELTINGSPOT_CSS_URL;
    document.head.appendChild(link);
};

const loadScript = () => {
    if (loadingPromise) {
        return loadingPromise;
    }
    if (window.MeltingSpot) {
        isReady.value = true;
        return Promise.resolve();
    }
    loadingPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = MELTINGSPOT_JS_URL;
        script.crossOrigin = 'anonymous';
        script.onload = () => {
            isReady.value = true;
            resolve();
        };
        script.onerror = (error) => {
            hasError.value = true;
            loadingPromise = null;
            reject(error);
        };
        document.head.appendChild(script);
    });

    return loadingPromise;
};

export function useMeltingSpot() {
    const load = async () => {
        loadCSS();
        await loadScript();
    };
    const bindDrawer = (elementId, widgetId) => {
        if (!window.MeltingSpot || boundElements.has(elementId)) {
            return;
        }
        boundElements.add(elementId);
        window.MeltingSpot.bindWidgetDrawerTo(elementId, {
            position: 'right',
            spotId: SPOT_ID,
            widgetId,
            themeMode: 'light',
        });
    };
    const unbindDrawer = (elementId) => {
        boundElements.delete(elementId);
    };
    const generateElementId = () => {
        return `meltingspot-widget-${instanceCounter++}`;
    };
    return {
        isReady,
        hasError,
        load,
        bindDrawer,
        unbindDrawer,
        generateElementId,
    };
}
